import { SVG } from '../SVG'

const PencilIcon = ({ style = {}, ...props }) => (
  <SVG
    width='36'
    height='36'
    viewBox='0 0 36 36'
    fill='none'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    xmlns='http://www.w3.org/2000/svg'
    style={{ stroke: 'var(--primary-color)', ...style }}
    {...props}
  >
    <path d='M13.589 29.4167H7.08903C6.80171 29.4167 6.52616 29.3026 6.323 29.0994C6.11983 28.8962 6.0057 28.6207 6.0057 28.3334V22.2803C6.0052 22.1396 6.03246 22.0002 6.0859 21.8701C6.13935 21.7399 6.21793 21.6216 6.31716 21.5219L22.5672 5.27192C22.668 5.16956 22.7881 5.08827 22.9206 5.03279C23.0531 4.9773 23.1954 4.94873 23.339 4.94873C23.4827 4.94873 23.6249 4.9773 23.7574 5.03279C23.8899 5.08827 24.0101 5.16956 24.1109 5.27192L30.1505 11.3115C30.2528 11.4123 30.3341 11.5325 30.3896 11.665C30.4451 11.7975 30.4737 11.9397 30.4737 12.0834C30.4737 12.227 30.4451 12.3693 30.3896 12.5018C30.3341 12.6343 30.2528 12.7544 30.1505 12.8553L13.589 29.4167Z' />
    <path d='M19.0057 8.83301L26.589 16.4163' />
    <path d='M29.839 29.4165H13.589L6.07341 21.9009' />
    <path d='M22.7974 12.625L9.79736 25.625' />
  </SVG>
)

export default PencilIcon
